/**
 * Text
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
var tagMapper = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    p: 'p',
    preamble: 'p',
    span: 'span',
    div: 'div',
    screenReader: 'div',
};
var typographyClasses = {
    h1: 'font-fontAlt font-semibold text-h1',
    h2: 'font-fontStandard font-semibold text-h2',
    h3: 'font-fontStandard font-semibold text-h3',
    h4: 'font-fontStandard font-semibold text-h4',
    h5: 'font-fontStandard font-semibold text-h5',
    h6: 'font-fontStandard font-semibold text-h6',
    p: 'font-fontStandard text-p',
    preamble: 'font-fontStandard text-preamble',
    span: '',
    div: '',
    screenReader: 'sr-only',
};
var typographyMarginClasses = {
    h1: 'mb-4',
    h2: 'mb-2 mt-7',
    h3: 'mt-7 mb-2',
    h4: 'mb-2',
    h5: 'mb-2',
    h6: 'mb-2',
    p: 'mb-4',
    preamble: 'mb-8',
    span: '',
    div: '',
    screenReader: '',
};
/** Text component to render texts, also has handling for Epi server on page editor. */
var Text = function (_a) {
    var children = _a.children, text = _a.text, styleAs = _a.styleAs, as = _a.as, _b = _a.margin, margin = _b === void 0 ? true : _b, _c = _a.className, className = _c === void 0 ? '' : _c, htmlAttributes = __rest(_a, ["children", "text", "styleAs", "as", "margin", "className"]);
    var content = children || text;
    var Component = tagMapper[as];
    if (!content) {
        return null;
    }
    return (React.createElement(Component, __assign({ className: clsx(typographyClasses[styleAs || as], margin && typographyMarginClasses[styleAs || as], className) }, htmlAttributes, { "data-cid": "Text" }), content));
};
export default Text;
